export class ValdtityDateModel {
dtValidityDate: string;
setValue(res){
if(res){
if(res['dtValidityDate']){this.dtValidityDate = res['dtValidityDate'];}
}
}
}